<template>
  <el-scrollbar>
    <label style="margin-left: 5px;font-weight: bold">员工信息:</label>
    <el-card style="margin: 5px" shadow="never">
      <el-form :model="selectEmployee" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名:">
              <el-input v-model="selectEmployee.employee_name"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工号:">
              <el-input v-model="selectEmployee.employee_no"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="部门:">
              <el-input v-model="selectEmployee.department_name"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="考勤月份:">
              <el-input v-model="selectEmployee.work_month_str"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">出勤统计:</label>
    <el-card style="margin: 5px" shadow="never">
      <el-form :model="selectEmployee" label-width="150px" disabled>
        <el-row>
          <el-col :span="12">
            <el-form-item label="应出勤(天):">
              <el-input v-model="selectEmployee.attendance_days"/>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="应出勤(时):">
              <el-input v-model="selectEmployee.attendance_hours"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="实出勤(时):">
              <el-input v-model="selectEmployee.actual_attendance_hours"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="年假(时):">
              <el-input v-model="selectEmployee.annual_hours"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="事假(时):">
              <el-input v-model="selectEmployee.personal_leave_hours"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="病假(时):">
              <el-input v-model="selectEmployee.sick_hours"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="调休(时):">
              <el-input v-model="selectEmployee.change_hours"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="婚假(时):">
              <el-input v-model="selectEmployee.marriage_hours"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产假(时):">
              <el-input v-model="selectEmployee.maternity_hours"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="产检假(时):">
              <el-input v-model="selectEmployee.maternity_check_hours"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="陪产假(时):">
              <el-input v-model="selectEmployee.paternity_hours"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="育儿假(时):">
              <el-input v-model="selectEmployee.child_care_hours"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="哺乳假(时):">
              <el-input v-model="selectEmployee.breastfeeding_hours"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="旷工(天):">
              <el-input v-model="selectEmployee.skip_work_days"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="漏卡(次):">
              <el-input v-model="selectEmployee.miss_check_times"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="迟到早退<5分钟(次):">
              <el-input v-model="selectEmployee.late_or_early_within_5_times"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="迟到早退<30分钟(次):">
              <el-input v-model="selectEmployee.late_or_early_within_30_times"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="迟到早退>30分钟(次):">
              <el-input v-model="selectEmployee.late_or_early_over_30_times"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <label style="margin-left: 5px;font-weight: bold">出勤明细:</label>
    <el-table :data="employeeAttendanceList" stripe border style="width: 99%;height: 80%;margin-top:5px" row-style="height:35px;" size="small">
      <el-table-column label="日期" prop="work_date_str" fixed width="60" align="center" ></el-table-column>
      <el-table-column label="星期" prop="work_week" width="45" align="center" ></el-table-column>
      <el-table-column label="工作日历" prop="work_calendar" width="70" align="center" ></el-table-column>
      <el-table-column label="上班打卡时间" prop="on_check_time" width="130" align="center" ></el-table-column>
      <el-table-column label="下班打卡时间" prop="off_check_time" width="130" align="center" ></el-table-column>
      <el-table-column label="正班工时" prop="work_hours" width="65" align="center" ></el-table-column>
      <el-table-column label="迟到(分钟)" prop="late_minutes" width="80" align="center" ></el-table-column>
      <el-table-column label="早退(分钟)" prop="leave_early_minutes" width="80" align="center" ></el-table-column>
      <el-table-column label="旷工(分钟)" prop="miss_minutes" width="80" align="center" ></el-table-column>
      <el-table-column label="加班工时" prop="overtime_hours" width="65" align="center" ></el-table-column>
      <el-table-column label="请假(H)" prop="leave_hours" width="60" align="center" ></el-table-column>
      <el-table-column label="请假信息" prop="leave_info" align="center" ></el-table-column>
    </el-table>
  </el-scrollbar>
</template>

<script>
import moment from "moment/moment";

export default {
  name: "AttendanceMonthDetail",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      optionProps: {
        emitPath:false,
        value: 'type',
        label: 'name'
      },
      loading: false,
      selectMonth:moment(new Date()).format('YYYY-MM'),
      selectEmployee:{},
      employeeAttendanceList:[]
    }
  },
  methods: {
    async getMonthReportDetail() {
      let params = {id:this.parentData.id,}
      let rtn = await this.$http('attendanceMonthService.getAttendanceMonthWithDetail',params);
      console.log(rtn);
      if(!rtn){
        return;
      }
      this.selectEmployee = rtn;
      this.employeeAttendanceList = rtn.detail;
    },
  },
  created() {
    this.getMonthReportDetail();
  }
}
</script>


<style scoped lang="less">

</style>